import { useCallback, useEffect, useRef, useState } from 'react';
import type { Account } from '../types';

export function useDashboardSelection(paged: Account[]) {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const toggleRow = useCallback((id: string) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const clearSelection = useCallback(() => setSelectedIds(new Set()), []);

  const allPagedSelected = paged.length > 0 && paged.every((a) => selectedIds.has(a.id));
  const somePagedSelected = paged.some((a) => selectedIds.has(a.id));

  const headerCheckboxRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (headerCheckboxRef.current) {
      headerCheckboxRef.current.indeterminate = somePagedSelected && !allPagedSelected;
    }
  }, [somePagedSelected, allPagedSelected]);

  const toggleAllPaged = useCallback(() => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (allPagedSelected) {
        paged.forEach((a) => next.delete(a.id));
      } else {
        paged.forEach((a) => next.add(a.id));
      }
      return next;
    });
  }, [allPagedSelected, paged]);

  return {
    selectedIds,
    toggleRow,
    toggleAllPaged,
    clearSelection,
    allPagedSelected,
    somePagedSelected,
    headerCheckboxRef,
  };
}